/* ---------------------------------------------------- */
/* Extract data value from the provided string			*/
/* ---------------------------------------------------- */

export default function extractDataValue( dataStringToProcess ) {

	let data = dataStringToProcess,
		returnValue,
		dataNew

	if ( null === data || undefined === data || '' === data ) {
		return false
	}

	data = data.replace( /\/\*(.*?)\*\//g, "" );

	// HasMedia?
	if ( -1 !== data.indexOf( "@media" ) ) {
		// Get media content
		dataNew = data.match( /\){(.*?)\}$/g );

		// re check for media.
		if ( dataNew == null ) {
			dataNew = data.match( /\{(.*?)\}$/g );
		}
	} else {
		dataNew = data;
	}

	// Value
	returnValue = dataNew.toString().split( /:(.+)/ )[1].split( "}" )[ 0 ];

	// Be sure
	if ( ! returnValue ) {
		return false
	}

	// who do like important tag?.
	returnValue = returnValue.replace( /\s+?!important/g, '' ).replace( /\;$/g, '' ).trim();

	// return
	return returnValue;
}



// WEBPACK FOOTER //
// ./dev/stylist_parent/functions/extract-data-value.js